// What a B-book screen last showed, kept while the app is open: coming back to a tab paints it at once and refreshes behind.
// The refresh button asks every live component to poll now, and marks the next few seconds as "read through the server cache".
const store = new Map()
const MAX_AGE_MS = 10 * 60 * 1000 // older than this, better a loader than a figure from before lunch
const REFRESH_EVENT = 'bbook:refresh'
let freshUntil = 0

export const recall = (key) => {
  const hit = store.get(key)
  return hit && Date.now() - hit.at < MAX_AGE_MS ? hit.value : undefined
}

export const remember = (key, value) => { store.set(key, { value, at: Date.now() }); return value }

export const requestRefresh = () => {
  freshUntil = Date.now() + 3000
  window.dispatchEvent(new CustomEvent(REFRESH_EVENT))
}

// services append it to the heavy endpoints, so a refresh reads through the server's short cache
export const freshParam = (url) => (Date.now() < freshUntil ? `${url}${url.includes('?') ? '&' : '?'}fresh=1` : url)

export const onRefresh = (handler) => {
  window.addEventListener(REFRESH_EVENT, handler)
  return () => window.removeEventListener(REFRESH_EVENT, handler)
}
